export enum KeywordToolLocationType {
    AutonomousCommunity = 'Autonomous Community',
    Canton = 'Canton',
    City = 'City',
    CongressionalDistrict = 'Congressional District',
    Country = 'Country',
    County = 'County',
    Department = 'Department',
    Governorate = 'Governorate',
    Municipality = 'Municipality',
    Prefecture = 'Prefecture',
    Province = 'Province',
    Region = 'Region',
    State = 'State',
    Territory = 'Territory',
    UnionTerritory = 'Union Territory',
}

export const KEYWORD_TOOL_LOCATION_TYPES = Object.values(KeywordToolLocationType);
